import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1901Component } from './kymw1901.component';

import {AppCommonsModule } from '../../../commons/app-commons.module';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { GetMembersVoiceOutputNumService } from './api-services/get-members-voice-output-num.service';
import { GetMembersVoiceOutputCSVService } from './api-services/get-members-voice-output-csv.service';

/**
 * 掲載組合員の声出力画面 モジュール設定クラス
 *
 * @export KYMW1901Module
 * @class KYMW1901Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW1901Component,
  ],
  providers: [
    FileDownloadConfirmService,
    FileDownloadService,
    GetMembersVoiceOutputNumService,
    GetMembersVoiceOutputCSVService,
  ],
})
export class KYMW1901Module {
}
